const numberToBase64 = (num: number) => {
  const cursorNumber = encodeURIComponent(num)
  /* 转为base64 */
  return btoa(cursorNumber).replace(/=/g, '')
}

export default numberToBase64
